import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseConfig';

/**
 * Reactive hook for Firebase Auth user state.
 * Returns { userId, user } that update when auth state changes.
 */
export function useAuthUser() {
  const [user, setUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return { userId: user?.uid || null, user };
}
